export default (string: any): string | null => {
  if (typeof string !== 'string' || string === '') {
    return null;
  }
  return string;
};
